function Research2025() {

    return (
        <>
            <div className="ml-10 mt-5">
                <div className="flex">
                    <div className="w-16">2025</div>
                    <div className="w-full">

                        <div className="flex">
                            <div className="w-16">June</div>
                            <div className="w-full">
                                <p><a href="https://www.i2m.univ-amu.fr/perso/stephane.charpentier/Pages-journees-speciales/Journee-AGT/Journee-AGT-2025.html" target='_blank'>“On Ext functors of modules induced via abelianization of free groups.”</a></p>
                                <p>Journée de l’équipe Analyse, Géométrie et Topologie 2025, Aix Marseille Universitié</p>
                            </div>
                        </div>

                        <div className="flex mt-2">
                            <div className="w-16">June</div>
                            <div className="w-full">
                                <p><a href="https://www.math.univ-paris13.fr/accueil/equipes/ta/seminaire-de-lequipe-ta/" target='_blank'>“Adjunctions between Module Categories via Left Ideals.”</a></p>
                                <p>Séminaire de l’équipe Topologie Algébrique, University Paris North</p>
                            </div>
                        </div>


                        <div className="flex mt-2">
                            <div className="w-16">June</div>
                            <div className="w-full">
                                <p><a href="https://lmno.unicaen.fr/seminaires/seminaire-dalgebre-et-de-geometrie/" target='_blank'>“On the intersection of the annihilators of polynomial functors.”</a></p>
                                <p>Séminaire d’algèbre et de géométrie, LMNO, Caen</p>
                            </div>
                        </div>

                        <div className="flex mt-2">
                            <div className="w-16">May</div>
                            <div className="w-full">
                                <p><a href="https://sites.google.com/g.ecc.u-tokyo.ac.jp/alg-approach-mcg/" target='_blank'>“The Lie operad as a subquotient of Jacobi diagrams in handlebodies.”</a></p>
                                <p>Algebraic approaches to mapping class groups of surfaces, the University of Tokyo</p>
                            </div>
                        </div>

                        <div className="flex mt-2">
                            <div className="w-16">Feb</div>
                            <div className="w-full">
                                <p><a href="https://park.itc.u-tokyo.ac.jp/MSF/topology/conference/EACGT20/" target='_blank'>“The Lie operad as a subquotient of Jacobi diagrams in handlebodies.”</a></p>
                                <p>The 20th East Asian Conference on Geometric Topology, the University of Tokyo</p>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </>
    );
}

export default Research2025;